import { FormControlLabel } from "@mui/material";
import { styled } from "@mui/material/styles";

import { RADIO_LABEL } from "ui/radio/radio.constants";

export const RadioLabel = styled(FormControlLabel)(({ theme }) => ({
  marginLeft: 0,
  marginRight: 0,
  gap: theme.spacing(RADIO_LABEL.gap),

  "& .MuiFormControlLabel-label": {
    ...theme.typography[RADIO_LABEL.variant],
    color: theme.palette.text.primary,

    "&.Mui-disabled": {
      color: theme.palette.text.disabled,
    },
  },
}));
